'use client';

export { default } from './InputBase';
export { default as inputBaseClasses } from './inputBaseClasses';
export * from './inputBaseClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/InputBase/index.js
// module id = 114
// module chunks = 25